var exports = {
  "_": "Showcase__NfEUYA",
};

module.exports = exports;
